/** Defines the possible user roles. */
const roles = {
  User: 'User',
  Administrator: 'Administrator',
  AccountManager: 'Accountmanager'
};

export default roles;
